<template>
  <div id="top">
    <div class="image_birds">
      <div class="image_birds_bg"></div>
    </div>
    <ContentHeader class="content" />
    <div class="features">
      <v-layout row justify-center>
        <h2>{{ $t('about.title') }}</h2>
        <p class="long-copy"></p>
      </v-layout>
      <div>
        <v-layout row wrap justify-center>
          <v-flex class="ml-10" md2 lg2 xs8 sm8>
            <v-img class="icon" src="../assets/pf.png"></v-img>
            <h3>Pascal De Munck</h3>
            <p>{{ $t('about.me') }}</p>
          </v-flex>
          <v-flex class="ml-10" md2 lg2 xs8 sm8>
            <v-img class="icon" src="../assets/passion_icon.png"></v-img>
            <h3>{{ $t('about.title_passion') }}</h3>
            <p>{{ $t('about.passion') }}</p>
          </v-flex>
          <v-flex class="ml-10" md2 lg2 xs8 sm8>
            <v-img class="icon" src="../assets/inspire_icon.png"></v-img>
            <h3>{{ $t('about.title_inspire') }}</h3>
            <p>{{ $t('about.inspire') }}</p>
          </v-flex>
          <v-flex class="ml-10" md2 lg2 xs8 sm8>
            <v-img class="icon" src="../assets/share_icon.png"></v-img>
            <h3>{{ $t('about.title_share') }}</h3>
            <p>{{ $t('about.share') }}</p>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div>
      <v-layout row justify-center>
        <h2>{{ $t('about.title_timeline') }}</h2>
        <p class="long-copy"></p>
      </v-layout>
      <v-timeline class="timeline">
        <v-timeline-item v-for="(year, i) in years" :key="i" :color="year.color" small>
          <template v-slot:opposite>
            <span :class="`headline font-weight-bold ${year.color}--text`" v-text="year.year"></span>
          </template>
          <div v-if="year.year=='2009'" class="py-4">
            <div>{{ $t('timeline.2009') }}</div>
          </div>
          <div v-if="year.year=='2010'" class="py-4">
            <div>{{ $t('timeline.2010') }}</div>
          </div>
          <div v-if="year.year=='2011'" class="py-4">
            <div>{{ $t('timeline.2011') }}</div>
          </div>
          <div v-if="year.year=='2013'" class="py-4">
            <div>{{ $t('timeline.2013') }}</div>
          </div>
          <div v-if="year.year=='2014'" class="py-4">
            <div>{{ $t('timeline.2014') }}</div>
          </div>
          <div v-if="year.year=='2016'" class="py-4">
            <div>{{ $t('timeline.2016') }}</div>
          </div>
          <div v-if="year.year=='2017'" class="py-4">
            <div>{{ $t('timeline.2017') }}</div>
          </div>
          <div v-if="year.year=='2018'" class="py-4">
            <div>{{ $t('timeline.2018') }}</div>
          </div>
          <div v-if="year.year=='2019'" class="py-4">
            <div>{{ $t('timeline.2019') }}</div>
          </div>
        </v-timeline-item>
      </v-timeline>
    </div>
    <Footer />
  </div>
</template>

<script>
import ContentHeader from "../components/ContentHeader.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "About",
  components: {
    ContentHeader,
    Footer
  },
  data: () => ({
    years: [
      {
        year: "2009"
      },
      {
        year: "2010"
      },
      {
        year: "2011"
      },
      {
        year: "2013"
      },
      {
        year: "2014"
      },
      {
        year: "2016"
      },
      {
        year: "2017"
      },
      {
        year: "2018"
      },
      {
        year: "2019"
      }
    ]
  }),
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped>
.timeline {
  width: 90%;
  position: absolute;
  left: 5%
}
.footer {
  position: absolute;
  width: 100%;
  top: 200%;
}

.content {
  width: 100%;
  height: 10%;
  background-color: black;
  position: absolute;
  top: 0%;
}

.image_birds {
  height: 55vh;
  width: 100%;
}

.image_birds_bg {
  width: 100%;
  height: 100%;
  background-image: url("../assets/about_header.jpg");
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
}

.features {
  margin-top: 50px;
  margin-bottom: 50px;
}
</style>